import { ResourceService } from '@socialbrothers/services';

import { ApiService } from '@Services/ApiService';

import { IAdmin } from './AdminService.props';

export class AdminServiceImplementation extends ResourceService<IAdmin> {}

export const AdminService = new AdminServiceImplementation(ApiService, '/admin/admins');
